<script setup lang="ts">
  import { computed } from 'vue';
  import { DocumentControlSection, DocumentControlValiditySection } from '@/features/Document';
  import { formatCivilDateToPtBR, formatInstantToPtBR } from '@/shared/lib';
  import RecordReadModal from './RecordReadModal.vue';
  import type {
    RecordControl,
    RecordControlStage,
    RecordModalTarget,
  } from '../model/record-modal.types';

  /**
   * Control of elaboration, approval, verification and homologation of a record,
   * in read only, on the same sections as the documents' control modal. The
   * opener fetches the control before the modal opens, so it never shows a frame
   * with nothing in it.
   */
  const props = defineProps<{
    target: RecordModalTarget;
    control: RecordControl;
  }>();

  const emit = defineEmits<{
    close: [];
  }>();

  const stageInfo = (stage: RecordControlStage | null) => ({
    responsible: stage?.memberName ?? '-',
    cargo: stage?.positionName ?? '-',
    date: formatInstantToPtBR(stage?.date),
  });

  /** Elaboração has no Cargo: the record stores none for the elaborator. */
  const elaboration = computed(() => ({
    responsible: props.control.elaboration.memberName ?? '-',
    date: formatInstantToPtBR(props.control.elaboration.date),
  }));
  const approval = computed(() => stageInfo(props.control.approval));
  const verification = computed(() => stageInfo(props.control.verification));
  const validityDate = computed(() => formatCivilDateToPtBR(props.control.effectiveDate));
</script>

<template>
  <RecordReadModal
    modal-title="Controle de Elaboração, Aprovação, Verificação e Homologação de Registros"
    form-title="CONTROLE DE ELABORAÇÃO, APROVAÇÃO, VERIFICAÇÃO E HOMOLOGAÇÃO DE REGISTROS"
    form-code="RQ05.1"
    form-revision-label="REV.08"
    :code="target.code"
    :print-compact="true"
    @close="emit('close')"
  >
    <div>
      <DocumentControlSection title="Elaboração" :section-info="elaboration" :show-cargo="false" />
      <DocumentControlSection title="Aprovação" :section-info="approval" />
      <DocumentControlSection title="Verificação" :section-info="verification" />
      <DocumentControlValiditySection :date="validityDate" />
    </div>
  </RecordReadModal>
</template>
